import "./MakerPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Image 1 Data
const enrichData = [
  {
    title: "FIRST LERNERS BOOKS",
    items: [
      "My picture books",
      "Learn Alphabet",
      "Learn Numbers",
      "Learn writing strokes",
      "Pictorial story books",
      "Learn Rhymes",
    ],
  },
  {
    title: "SCHOOL BOOKS",
    items: [
      "Pre-school books",
      "Pre-primary books",
      "Primary books",
      "Cut and paste Posters",
      "Learn Computers",
      "Practical mathematics",
    ],
  },
  {
    title: "GK AND SCIENCE",
    items: [
      "Do it yourself books",
      "Science experiments",
      "Fun Facts books",
      "My discovery books",
      "My GK & IQ books",
      "My memory builder",
    ],
  },
  {
    title: "LANGUAGE BOOKS",
    items: [
      "Grammer books",
      "Learn language books",
      "Story books in languages",
      "Comics for learn language",
      "Dictionaries in languages",
      "Essey writing books",
    ],
  },
  {
    title: "CREATIVE BOOKS",
    items: [
      "Learn art Step by step",
      "Learn craft books",
      "Pencil Art books",
      "My Colouring books",
      "Learn writing skills books",
      "DIY (do it yourself creatives)",
    ],
  },
  {
    title: "ACTIVITY BOOKS",
    items: [
      "Brain teaser books",
      "Puzzlink",
      "Do it Your self",
      "Play ground puzzles",
      "Chhota Vikram puzzle story",
      "Fun Magic tricks",
    ],
  },
];

export default function EnrichPage() {
  return (
    <div className="enrichWrapper" style={{backgroundColor:"#d7b1ff"}}>
      {enrichData.map((section) => (
        <div className="enrichColumn" key={section.title}>
          <div className="enrichHeading">
            <span className="enrichTitle">{section.title}</span>
          </div>

          <ul className="enrichList">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="enrichArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}